<!---header-text-light: bg-focus| bg-success | bg-warning | bg-primary | bg-secondary | bg-dark | bg-alternate | bg-vicious-stance|
bg-royal|bg-warm-flame|bg-premium-dark|bg-strong-bliss----->

<div class="app-header header-shadow bg-white header-text-dark">
  <!--can add above class to this level for color combination-->
  <div class="app-header__logo">
    <div class="logo-src"></div>
    <div class="header__pane ml-auto">
      <div>
        <button type="button" (click)="onToggleSidebar()" class="hamburger close-sidebar-btn hamburger--elastic "
          data-class="closed-sidebar">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>

  </div>
  <div class="app-header__mobile-menu">
    <div>
      <button type="button" (click)="onToggleSidebar()" class="hamburger hamburger--elastic mobile-toggle-nav">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>
  </div>
  <div class="app-header__menu">
    <span>
      <button type="button" class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
        <span class="btn-icon-wrapper">
          <i class="fa fa-ellipsis-v fa-w-6"></i>
        </span>
      </button>
    </span>
  </div>
  <div class="app-header__content">
    <h5 class="Page-header" style="margin-bottom:0px; margin-left: -27px; font-size: 16px; font-weight: 500;">
      {{common.pageTitle}}</h5>
    <!--Header Search-->
    <!-- <div class="app-header-left">
            <div class="search-wrapper" [class.active]="isSearchActive">
                <div class="input-holder">
                    <input type="text" class="search-input" placeholder="Type to search">
                    <button class="search-icon" (click)="activateSearch()"><span></span></button>
                </div>
                <button class="close" (click)="deactivateSearch()"></button>
            </div>
        </div> -->

    <div class="app-header-right">
      <div class="notification-btn px-3 mx-2">
        <div class="btn-group">
          <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="p-0 btn btn-notify">
            <span class="icon"><i class="fa fa-bell"></i></span>
            <span class="badge badge-pill badge-dark badge-count">99+</span>
          </a>
          <div tabindex="-1" role="menu" aria-hidden="true" class="dropdown-menu dropdown-menu-right">
            <button type="button" tabindex="0" class="dropdown-item">User Account</button>
            <button type="button" tabindex="0" class="dropdown-item">Settings</button>
            <h6 tabindex="-1" class="dropdown-header">Header</h6>
            <button type="button" tabindex="0" class="dropdown-item">Actions</button>
            <div tabindex="-1" class="dropdown-divider"></div>
            <button type="button" tabindex="0" class="dropdown-item">Dividers</button>
          </div>
        </div>
      </div>
      <div class="header-btn-lg pr-0">
        <div class="widget-content p-0">
          <div class="widget-content-wrapper">
            <div class="widget-content-left">
              <div class="btn-group">
                <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="p-0 btn">
                  <img width="36" class="rounded-circle mx-1" src="assets/images/avatars/avtar.jpg" alt="">
                  <span><strong> {{data.userInfo.userName || ''}}</strong></span>
                  <i class="fa fa-angle-down ml-2 opacity-8"></i>
                </a>
                <div tabindex="-1" role="menu" aria-hidden="true" class="dropdown-menu dropdown-menu-right">
                  <!-- <button type="button" tabindex="0" class="dropdown-item">User Account</button>
                                    <button type="button" tabindex="0" class="dropdown-item">Settings</button>
                                    <h6 tabindex="-1" class="dropdown-header">Header</h6>
                                    <button type="button" tabindex="0" class="dropdown-item">Actions</button>
                                    <div tabindex="-1" class="dropdown-divider"></div> -->
                  <button type="button" tabindex="0" class="dropdown-item" (click)="goToPage('/login')">Log out</button>
                </div>
              </div>
            </div>
            <!-- <div class="widget-content-left  ml-3 header-user-info">
                            <div class="widget-heading">
                                Alina Mclourd
                            </div>
                            <div class="widget-subheading">VP People Manager</div>
                        </div> -->
            <!-- <div class="widget-content-right header-user-info ml-3">
                            <button type="button" class="btn-shadow p-1 btn btn-primary btn-sm show-toastr-example">
                                <i class="fa text-white fa-calendar pr-1 pl-1"></i>
                            </button>
                        </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>